import { DynamicVariables } from "./Common/DynamicVariables";
import * as Managers from "./Exporters/ManagersExporter";

import { registerLicense } from '@syncfusion/ej2-base';


export class App {

    public static SideBar : Managers.SideBarManager;

    constructor() {

        DynamicVariables.initialize();

        this.clearSyncfusionGridPersistenceOnCompanySelectPage();

        $(document).ajaxComplete(function (event, xhr, settings) { $('button').blur(); });

        registerLicense('NxYtFisQPR08Cit/VkR+XU9Ff1RDX3xKf0x/TGpQb19xflBPallYVBYiSV9jS3hTd0VqWXpfcHZdRGlYWE91XQ==;Ix0oFS8QJAw9HSQvXkViQlBad1ZJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxVdkRjUH9bcXRXTmNdUUF9XEA=;IAk8BicRIAEqCzQhAR8kAxMHIgRJXmFXf013TGhYfUFzdUpPaVVYVHdeSFhqQ3taZiUeUn1ecnJVR2BVUUF3X0BVYE18UH1GYQ==');

        $('#sidebar').each((index, element) => {
            App.SideBar = new Managers.SideBarManager($(element));
            App.SideBar.initialize();
        });

        this.setCustomFunctions();
        
        new Managers.DiagnosticsManager($('#diagnostics-container')).initialize();

        $('#excel-upload-container').each((index, element) => {
            new Managers.ExcelUploadOverviewManager($(element)).initialize();
        });

        $('#create-enquiry-workbook-container').each((index, element) => {
            new Managers.CreateEnquiryWorkbookManager($(element)).initialize();
        });        
        
        $('#process-enquiry-container').each((index, element) => {
            new Managers.ProcessEnquiryManager($(element)).initialize();
        });

        $('#enquiries-overview-container').each((index, element) => {
            new Managers.EnquiryOverviewManager($(element)).initialize();
        });

        $('#login-container').each((index, element) => {
            new Managers.LoginManager($(element)).initialize();
        });

        $('#verify-code-container').each((index, element) => {
            new Managers.VerifyCodeManager($(element)).initialize();
        });

        $('#impa-common-table-container').each((index, element) => {
            new Managers.ImpaTableManager($(element)).initialize();
        });        
        
        $('#cross-refrences-common-table-container').each((index, element) => {
            new Managers.CrossReferencesManager($(element)).initialize();
        });        
        
        $('#uom-cross-refrences-common-table-container').each((index, element) => {
            new Managers.UoMCrossReferencesManager($(element)).initialize();
        });        
        
        $('#vessel-cross-refrences-common-table-container').each((index, element) => {
            new Managers.VesselCrossReferencesManager($(element)).initialize();
        });          
        
        $('#department-cross-refrences-common-table-container').each((index, element) => {
            new Managers.DepartmentCrossReferencesManager($(element)).initialize();
        });        
        
        $('#customer-cross-refrences-common-table-container').each((index, element) => {
            new Managers.CustomerCrossReferencesManager($(element)).initialize();
        });

        $('#data-warehouse-index-container').each((index, element) => {
            new Managers.DataWarehouseIndexManager($(element)).initialize();
        });        
        
        $('#excel-formats-page-container').each((index, element) => {
            new Managers.ExcelFormatsManager($(element)).initialize();
        });

        
        $('#dwh-document-details-view-container').each((index, element) => {
            new Managers.DataWarehouseDetailManager($(element)).initialize();
        });          
        
        $('#unable-to-connect-container').each((index, element) => {
            new Managers.UnableToConnectManager($(element)).initialize();
        });           
        
        $('#users-index-container').each((index, element) => {
            new Managers.UsersManager($(element)).initialize();
        });            
        
        $('#workload-manager-container').each((index, element) => {
            new Managers.WorkloadIndexManager($(element)).initialize();
        });  
        
        $('#workload-operators-container').each((index, element) => {
            new Managers.WorkloadOperatorsManager($(element)).initialize();
        });          
        
        $('#data-hub-index-container').each((index, element) => {
            new Managers.DataHubIndexManager($(element)).initialize();
        });          
        
        $('#import-data-queue-manager-container').each((index, element) => {
            new Managers.ImportDataQueueManager($(element)).initialize();
        });          
        
        $('#import-data-validate-import-doc-header-manager-container').each((index, element) => {
            new Managers.ImportDocHeaderInfoManager($(element)).initialize();
        });  

        $('#validate-import-doc-header-container').each((index, element) => {
            new Managers.ImportValidateDocHeaderManager($(element)).initialize();
        });          
        
        $('#ai-usage-container').each((index, element) => {
            new Managers.AIUsageManager($(element)).initialize();
        });  

        $('#admin-ai-usage-container').each((index, element) => {
            new Managers.AdminAIUsageManager($(element)).initialize();
        });  
        
        $('#error-logs-container').each((index, element) => {
            new Managers.ErrorLogManager($(element)).initialize();
        });          
        
        $('#import-email-inbox-manager-container').each((index, element) => {
            new Managers.ImportInboxManager($(element)).initialize();
        });  

        $('#admin-settings-page').each((index, element) => {
            new Managers.SettingsManager($(element)).initialize();
        });          
        
        $('#logbook-index-container').each((index, element) => {
            new Managers.LogbookManager($(element)).initialize();
        });          
        
        $('#task-manager-container').each((index, element) => {
            new Managers.TaskOverviewManager($(element)).initialize();
        });         
        
        $('#my-workload-container').each((index, element) => {
            new Managers.MyWorkloadManager($(element)).initialize();
        });          
        
        $('#information-page').each((index, element) => {
            new Managers.InformationPageManager($(element)).initialize();
        });         
        
        $('#admin-documentation-container').each((index, element) => {
            new Managers.DocumentationManager($(element)).initialize();
        });          
        
        $('#admin-version-history-container').each((index, element) => {
            new Managers.VersionHistoryManager($(element)).initialize();
        });          
        
        $('#admin-web-scraper-portal-templates-container').each((index, element) => {
            new Managers.WebScraperPortalTemplateManager($(element)).initialize();
        });          
        
        $('#web-scraper-portal-configurator-container').each((index, element) => {
            new Managers.WebScraperPortalConfiguratorContainer($(element)).initialize();
        });  
        

        $('#success-alert-box').delay(10000).fadeOut(300);

        //var cultureSelectList = $('#culture-selectlist');
        //cultureSelectList.on('change', () => {
        //    DataService.CommonDataService.setCulture(cultureSelectList.val(), () => {
        //        location.reload();
        //    })
        //})

    }

    private clearSyncfusionGridPersistenceOnCompanySelectPage(): void {
        // const hasSelectCompanyForm = document.querySelector<HTMLFormElement>(
        //     'form[action="/?handler=SelectCompany"]'
        // ) !== null;

        // if (!hasSelectCompanyForm) {
        //     return;
        // }

        const syncfusionPrefixes = [
            'grid',
            'toolbar',
        ];

        Object.keys(localStorage)
            .filter(key => syncfusionPrefixes.some(prefix => key.startsWith(prefix)))
            .forEach(key => localStorage.removeItem(key));
    }



    private setCustomFunctions() {
        (<IWindow>window).getStatus = (status: string, statusText: string) => {
            let workbookStatusses: Object = { '0': 'new', '1': 'ready-to-process', '2': 'ready-to-create-enquiry', '3': 'upload-successfull'};
            return '<span class="workbook-status workbook-status-' + workbookStatusses[status] + '">' + statusText + '</span>';
        };        
        
        (<IWindow>window).getWorksheetActions = (id:string, status: string, canProcess: boolean) => {
            
            if(status == "0") {
                return '<button class="btn btn-sm btn-primary me-2" data-action="view-workbook"><i class="fa-solid fa-eye"></i></button>' +
                canProcess ? '<button class="btn btn-sm btn-danger" data-action="remove-workbook"><i class="fa-solid fa-trash"></i></button>' : '' ;
            }

            if(status == "1") {
                if(canProcess) {
                    return `<a class="btn btn-sm btn-primary me-2" href="/Company/Excel/Upload/${id}/CreateEnquiry">Process file</a>` +
                    '<button class="btn btn-sm btn-primary me-2" data-action="view-workbook"><i class="fa-solid fa-eye"></i></button>' +
                    '<button class="btn btn-sm btn-danger" data-action="remove-workbook"><i class="fa-solid fa-trash"></i></button>';
                }

                return '<button class="btn btn-sm btn-primary me-2" data-action="view-workbook"><i class="fa-solid fa-eye"></i></button>'
            }

            if(status == "2") {
                if(canProcess) {
                    return `<a class="btn btn-sm btn-primary me-2" href="/Company/Excel/Enquiry/${id}/ProcessEnquiry">Create enquiry</a>` +
                    '<button class="btn btn-sm btn-primary me-2" data-action="view-workbook"><i class="fa-solid fa-eye"></i></button>' +
                    '<button class="btn btn-sm btn-danger" data-action="remove-workbook"><i class="fa-solid fa-trash"></i></button>';
                }

                return '<button class="btn btn-sm btn-primary me-2" data-action="view-workbook"><i class="fa-solid fa-eye"></i></button>'
            }

            if(status == "4") {
                if(canProcess) {
                    return '<button class="btn btn-sm btn-primary me-2" data-action="view-workbook"><i class="fa-solid fa-eye"></i></button>' +
                    '<button class="btn btn-sm btn-danger" data-action="remove-workbook"><i class="fa-solid fa-trash"></i></button>';
                }

                return '<button class="btn btn-sm btn-primary me-2" data-action="view-workbook"><i class="fa-solid fa-eye"></i></button>'
            }

            return '<button class="btn btn-sm btn-primary" data-action="view-workbook"><i class="fa-solid fa-eye"></i></button>';
        };         
        
        (<IWindow>window).getExcelFormatExtraActions = (id:string, mostRecentDocHeaderGuid: string) => {
            var html = "<div class=\"d-flex justify-content-end\">"
            if(mostRecentDocHeaderGuid != undefined && mostRecentDocHeaderGuid.length > 0) {
                html += `<button class="btn btn-xs btn-primary me-2" data-action="view-format" data-most-recent-doc-header-id="${mostRecentDocHeaderGuid}"><i class="fa-solid fa-eye"></i></button>`;
            }
            else {
                html += `<button class="btn btn-xs btn-primary me-2" disabled><i class="fa-solid fa-eye"></i></button>`;
            }
            
            html += `<button class="btn btn-xs btn-danger" data-action="remove-format"><i class="fa-solid fa-trash"></i></button>`;

            html += "</div>"

            return html;
        };        
        
        (<IWindow>window).getDocHeaderErpActions = (id:string, status: string, canProcess: boolean, erpSourceVesselXrefSet : boolean, erpSourceCustomerXrefSet : boolean, canCreateErpSourceDepartmentXref : boolean, erpSourceDepartmentXrefSet : boolean) => {
            var html = "<div class=\"d-flex erp-actions-container\">"
            

            if(DynamicVariables.ErpDepartmentsEnabled) {
                html += `<i data-action="${erpSourceDepartmentXrefSet ? "" : "create-erp-department"}" class=\"fa-solid fa-store my-auto ${canCreateErpSourceDepartmentXref ? "xref-button" : ""} me-3 ${erpSourceDepartmentXrefSet ? "text-success" : "text-danger"}\"></i>`;
            }


            html += `<i data-action="${erpSourceCustomerXrefSet ? "" : "create-erp-customer"}" class=\"fa-solid fa-user my-auto xref-button me-3 ${erpSourceCustomerXrefSet ? "text-success" : "text-danger"}\"></i>`;
            html += `<i data-action="${erpSourceVesselXrefSet ? "" : "create-erp-vessel"}" class=\"fa-solid fa-ship my-auto xref-button me-3 ${erpSourceVesselXrefSet ? "text-success" : "text-danger"} \"></i>`;
            
            // if(status == "0" && canProcess) {
            //     html += '<button class="btn btn-xs btn-primary" data-action="sent-to-erp" title="Send to ERP"><i class="fa-solid fa-circle-right"></i></button>';
            // }

            html += "</div>"
            
            return html;
        };              
    
        (<IWindow>window).getUoMCrossReferencesExtraActions = (id:string) => {
            return `<button class="btn btn-xs btn-danger" data-action="remove-uom" data-entity-id="${id}"><i class="fa-solid fa-trash"></i></button>`;
        };

        (<IWindow>window).getVesselCrossReferencesExtraActions = (id:string) => {
            return `<button class="btn btn-xs btn-danger" data-action="remove-vessel-xref" data-entity-id="${id}"><i class="fa-solid fa-trash"></i></button>`;
        };

        (<IWindow>window).getCustomerCrossReferencesExtraActions = (id:string) => {
            return `<button class="btn btn-xs btn-danger" data-action="remove-customer-xref" data-entity-id="${id}"><i class="fa-solid fa-trash"></i></button>`;
        }; 

        (<IWindow>window).getErpCustomersExtraActions = (id:string) => {
            return `<button class="btn btn-xs btn-primary" data-action="edit-erp-customer-article-cross-references" data-entity-id="${id}" title="Edit article cross references"><i class="fa-solid fa-shuffle"></i></button>`;
        };        
        
        (<IWindow>window).getCustomerArticleCrossReferencesExtraActions = (id:string) => {
            return `<button class="btn btn-xs btn-danger" data-action="remove-customer-article-xref" data-entity-id="${id}"><i class="fa-solid fa-trash"></i></button>`;
        };
        
        
        (<IWindow>window).getManualVesselsExtraActions = (id:string) => {
            return `<button class="btn btn-xs btn-danger" data-action="remove-erp-vessel" data-entity-id="${id}"><i class="fa-solid fa-trash"></i></button>`;
        };        
        
        (<IWindow>window).getDepartmentCrossReferencesExtraActions = (id:string) => {
            return `<button class="btn btn-xs btn-danger" data-action="remove-department-xref" data-entity-id="${id}"><i class="fa-solid fa-trash"></i></button>`;
        };

        (<IWindow>window).getUsersActions = (id:string) => {
            var html = "<div class=\"d-flex justify-content-end\">"
            html += `<button class="btn btn-sm btn-primary me-2" data-action="edit-user" data-user-link-id="${id}"><i class="fa-solid fa-pen"></i></button>`;
            html += `<button class="btn btn-sm btn-danger" data-action="remove-user" data-user-link-id="${id}"><i class="fa-solid fa-trash"></i></button>`;

            html += "</div>"

            return html;
        };

        (<IWindow>window).getWorkloadItemCheckbox = (id:string) => {
            return `<div class="d-flex" style="width:13px; height:13px"><input class="my-auto" type="checkbox" data-item-id="${id}" /></div>`;
        };  
        
        (<IWindow>window).getTaskItemCheckbox = (id:string) => {
            return `<div class="d-flex" style="width:13px; height:13px"><input class="my-auto" type="checkbox" data-item-id="${id}" /></div>`;
        };
        
        (<IWindow>window).getCreatedByTemplate = (createdBy:string, createdByInitials:string) => {
            if(createdBy === '<SYSTEM>') {
                return '<i class="fa-solid fa-robot text-color-primary"></i>'
            }

            return `<label class="label-clickable" data-bs-toggle="tooltip" title="${createdBy}">${createdByInitials}</label>`;
        };        
        
        (<IWindow>window).getDoesDocHeaderForDataHubItemStillExist = (doesStillExist:boolean) => {
            if(doesStillExist == true) {
                return '<i class="fa-solid fa-circle text-color-secondary"></i>'
            }

            return '<i class="fa-solid fa-circle text-danger" data-bs-toggle="tooltip" title="Enquiry is deleted in Data Warehouse"></i>'
        };


        (<IWindow>window).getDwhStatusField = (id:string, status: string, statusText: string, canProcess: boolean, isQuoted: boolean, discarded: boolean, manuallyQuoted : boolean) => {
            var html = "<div class=\"d-flex justify-content-between\">"
            
            if(manuallyQuoted) {
                html += `<label>${statusText}<i class="fa-solid fa-flag my-auto ms-2 manually-quoted-flag"></i></label>`;
            }
            else {
                html += `<label>${statusText}</label>`;
            }
            
            if((DynamicVariables.WorkloadmanagerEnabled && DynamicVariables.IsUserWorkloadManager) || (canProcess && !isQuoted && !discarded)) {
                var dropdownListItems = '';
                if(canProcess && !isQuoted && !discarded) {
                    dropdownListItems += '<li><a data-action="finish-dwh-enquiry" class="dropdown-item" href="#"><i  class=\"fa-solid fa-flag my-auto me-2\"></i> Mark as quoted</a></li>'
                }

                if(DynamicVariables.IsUserWorkloadManager && DynamicVariables.TaskmanagerEnabled) {
                    dropdownListItems += '<li><a data-action="add-project-task-button" class="dropdown-item" href="#"><i class="fa-solid fa-clipboard" style="margin-right: 1rem"></i>Add new task</a></li>';
                }
                
                if(dropdownListItems.length > 0) {
                    html += `<div class="btn-group dropstart btn-group-extra-info">
                        <button type="button" class="btn btn-secondary dropdown-toggle btn-extra-info" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="fa-solid fa-ellipsis-vertical"></i>
                        </button>
                        <ul class="dropdown-menu">
                            ${dropdownListItems}
                        </ul>
                    </div>`;
                }
            }

            html += "</div>"
            
            return html;
        };   

        (<IWindow>window).getLogbookItemLink = (id:string, customerReference:string, ourReference:string) => {
            var text = '';
            if(customerReference != null && customerReference.length > 0) {
                text += customerReference;
            }

            if(ourReference != null && ourReference.length > 0) {
                if(text.length == 0) {
                    text += ourReference;
                }
                else {
                    text += ` (${ourReference})`;
                }
                
            }

            return `<a target="_blank" href="/Company/DataWarehouse/${id}/Details">${text}</a>`;
        };         
        
        (<IWindow>window).getLogbookItemAcknowledeButton = (status:string) => {
            var html = "<div class=\"d-flex justify-content-end\">"

            if(status == 'New') {
                html += `<label class="label-clickable px-2 border-ssdr-green" data-action="acknowledge-log-item"><i class="fa-solid fa-check text-success"></i></label>`;
            }
        
            html += "</div>"

            return html;
        };         
        
        (<IWindow>window).getTaskItemLinkName = (linkType:string, linkName:string, linkId:string) => {
            if(linkType == 'Project') {
                if(linkName.length > 0 && linkId.length > 0 && linkName != '<DELETED>') {
                    return `<a target="_blank" href="/Company/DataWarehouse/${linkId}/Details">${linkName}</a>`;
                }
                else {
                    return `<span>${linkName}</span>`
                }
            }
            else {
                return `<span>${linkName}</span>`
            }
        }; 

        (<IWindow>window).getTaskButtons = (id:string, status:string) => {
            var html = "<div class=\"d-flex justify-content-end\">"

            if(status == 'OPEN') {
                html += `<button class="btn btn-xxs btn-success me-1" data-action="start-task" data-task-id="${id}"><i class="fa-solid fa-play"></i></button>`;
            }
            else if(status == 'STARTED') {
                html += `<button class="btn btn-xxs btn-success me-1" data-action="finish-task" data-task-id="${id}" style="padding-left: .25rem; padding-right: .25rem;"><i class="fa-solid fa-flag"></i></button>`;
            }

            html += `<button class="btn btn-xxs btn-primary me-1" data-action="edit-task" data-task-id="${id}" style="padding-left: .25rem; padding-right: .25rem;"><i class="fa-solid fa-pen"></i></button>`;
            html += `<button class="btn btn-xxs btn-danger" data-action="remove-task" data-task-id="${id}"><i class="fa-solid fa-trash"></i></button>`;

            html += "</div>"

            return html;
        };

        (<IWindow>window).getMyWorkloadTaskButtons = (id:string, status:string) => {
            var html = "<div class=\"d-flex justify-content-end\">"

            if(status == 'OPEN') {
                html += `<button class="btn btn-xxs btn-success me-1" data-action="start-task" data-task-id="${id}"><i class="fa-solid fa-play"></i></button>`;
            }
            else if(status == 'STARTED') {
                html += `<button class="btn btn-xxs btn-success me-1" data-action="finish-task" data-task-id="${id}" style="padding-left: .25rem; padding-right: .25rem;"><i class="fa-solid fa-flag"></i></button>`;
            }

            html += "</div>"

            return html;
        };        
        
        (<IWindow>window).getDataHubIndexSendToCloudErpEnabledExtraActions = (hasExportLogItems : boolean) => {
            var html = "<div class=\"d-flex justify-content-end\">"
            if(hasExportLogItems) {
                html += `<button class="btn btn-xxs btn-primary me-1" data-action="view-export-log"><i class="fa-solid fa-file-lines"></i></button>`;
            }
            else {
                html += `<button class="btn btn-xxs btn-primary me-1" disabled><i class="fa-solid fa-file-lines"></i></button>`;
            }
            
            html += "</div>"

            return html;
        };

        (<IWindow>window).getAdminWebScraperExtraActions = () => {
            var html = "<div class=\"d-flex justify-content-end\">"

            html += `<button class="btn btn-xxs btn-success me-1" data-action="push-config"><i class="fa-solid fa-arrow-right"></i></button>`;

            html += "</div>"

            return html;
        };  
    }
}